<template>
	<v-app>
		<nav-drawer />
		<v-main>
			<dialog-disabled />
			<menu-top notime="true" />
			<div class="gum-container">
				<v-img :src="Banner001" min-height="100" max-height="200" />
				<section-info-yarmarka />

				<section-time />

				<v-row>
					<v-col>
						<v-img :src="Banner003" class="mb-3" />
					</v-col>
				</v-row>
				<section-map-yarmarka class="mb-12" />
				<yandex-map />
				<section-gallery-yarmarka class="mb-12" />
				<section-partners class="mb-12" />
				<section-infopartners class="mb-15" />
				<the-footer />
			</div>
		</v-main>
	</v-app>
</template>

<script lang="ts">
import './style.less';

import Vue from 'vue';
import MenuTop from './components/MenuTop.vue';
import SectionGalleryYarmarka from './components/SectionGalleryYarmarka.vue';
import SectionInfoYarmarka from './components/SectionInfoYarmarka.vue';
import SectionMapYarmarka from './components/SectionMapYarmarka.vue';
import YandexMap from './components/YandexMap.vue';
import NavDrawer from './components/NavDrawer.vue';
import DialogDisabled from './components/Generic/DialogDisabled.vue';
import SectionTime from './components/SectionTime.vue';
import SectionPartners from './components/SectionPartners.vue';
import SectionInfopartners from './components/SectionInfopartners.vue';
import TheFooter from './components/Generic/TheFooter.vue';

export default Vue.extend({
	components: {
		MenuTop,
		SectionInfoYarmarka,
		YandexMap,
		SectionMapYarmarka,
		SectionGalleryYarmarka,
		NavDrawer,
		SectionPartners,
		DialogDisabled,
		SectionTime,
		SectionInfopartners,
		TheFooter,
	},
	name: 'App',

	data: () => ({
		Banner001: require('@/assets/images/banners/2023/yarmarka.jpg'),
		Banner003: require('@/assets/images/banners/2023/003.png'),
	}),
	created(): void {
		//
	},
});
</script>

<style scoped lang="less">
.gum-container {
	max-width: 1400px;
	margin-inline: auto;
	overflow: hidden;
}
</style>
